import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import mapStateToProps from './mapStateToProps';

// import useStyles from './useStyles';

import { Autocomplete, Typography, TextField, } from '@mui/material'
import SaveStatus from '../SaveStatus';


function DirecttorySelect(props) {
  const {
    value,
    label,
    dirName,
    disableGetting=false,
    onChange = () => { },
    onBlur = () => { },
    hideLabel = false,
    ...other
  } = props


  const insternalChange = (foo, item={}) => {
    onChange(item?.id)
  }

  const {
    shorts = {},
    loadShortDirectory = () => { },
  } = useSelector(mapStateToProps)

  /**загружаем краткий справочник выпадашек */
  useEffect(() => {
    if (dirName && !shorts[dirName] && !disableGetting) {
      loadShortDirectory(dirName)
    }
  }, [dirName, shorts, disableGetting])

  /**текущий справочник (если есть) */
  const curDir = dirName ? shorts[dirName] : undefined;
  const getDirValueByVal = (val) => {
    const tmprez = curDir?.find(({ id }) => id === val)

    return curDir?.find(({ id }) => id === val)
  }
  const getLabel = (data) => {
    const { label } = data;

    return label
  }

  return (<>

    {!hideLabel ? (
      <Typography variant="caption">
        {label}
      </Typography>
    ) : null}
    {curDir ? (
      <Autocomplete
        disablePortal
        options={curDir}
        value={getDirValueByVal(value)}
        size='small'
        fullWidth
        variant="outlined"
        getOptionLabel={getLabel}
        // onChange={(e, newValue) => onChange(newValue?.id)}
        onChange={insternalChange}
        renderInput={(params) => <TextField {...params} />}
        {...other}
      />
    ) : (
      <SaveStatus title="Загрузка выпадающего списка" dataObj={{ loading: true }} />
    )}
  </>)

}



export default DirecttorySelect;
